import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-choose-aria',
  templateUrl: './choose-aria.component.html',
  styleUrls: ['./choose-aria.component.scss']
})
export class ChooseAriaComponent {

}
